import { WorkerProject } from '../../types/worker.types';
import { WorkerHeader } from './WorkerHeader';

interface WorkerLayoutProps {
  children: React.ReactNode;
  project: WorkerProject;
  onBack?: () => void;
  showBackButton?: boolean;
  title?: string;
}

export function WorkerLayout({ 
  children, 
  project, 
  onBack, 
  showBackButton = false, 
  title 
}: WorkerLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <WorkerHeader 
        project={project} 
        onBack={onBack}
        showBackButton={showBackButton}
        title={title}
      />
      
      <main className="p-4 pb-20 max-w-md mx-auto">
        {children}
      </main>
    </div>
  );
}